export default __webpack_public_path__ + "images/642ddafa05296e770132104e6491b427.svg";